import { Avatar, IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import SearchIcon from "@material-ui/icons/Search";
import RateReviewOutlinedIcon from "@material-ui/icons/RateReviewOutlined";
import ReplyAllOutlinedIcon from "@material-ui/icons/ReplyAllOutlined";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SidebarChat from "./SidebarChat";
import { useSelector } from "react-redux";
import { selectUser } from "./features/userSlice";
import db, { auth } from "./firebase";
import firebase from "firebase";

function Sidebar() {

    // REDUX get user info from state
    const user = useSelector(selectUser);

    const [chats, setChats] = useState([]);

    useEffect(() => {
        db.collection("chats").orderBy('timestamp', 'desc').onSnapshot((snapshot) =>
            setChats(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            )
        );
    }, []);



    const addChat = () => {
        const chatName = prompt("Please enter a chat name");

        if (chatName) {
            db.collection("chats").add({
                chatName: chatName,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                createdBy: user.displayName,
            });
        }
    };

    return (
        <div className="sidebar">
            <div className="sidebar__header">
                <Avatar
                    // onClick={() => auth.signOut()}
                    // src={user.photo}
                    src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a60c69b4-dbdc-49e3-b152-43bbdbfb0160/d6dy6qy-19e320f2-932f-4549-8050-2b7fb9289eda.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvYTYwYzY5YjQtZGJkYy00OWUzLWIxNTItNDNiYmRiZmIwMTYwXC9kNmR5NnF5LTE5ZTMyMGYyLTkzMmYtNDU0OS04MDUwLTJiN2ZiOTI4OWVkYS5wbmcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.AQSIo8n9g9HHLZFVdCwqbDOjFg9DwZI35LCTIuLgtEw"

                    className="sidebar__avatar"
                />
                <div className="sidebar__input">
                    <SearchIcon />
                    <input placeholder="Search" />
                </div>

                <IconButton variant="outlined" className="sidebar__inputButton">
                    <RateReviewOutlinedIcon onClick={addChat} />
                </IconButton>
            </div>

            <div className="sidebar__chats">
                {chats.map(({ id, data: { chatName, createdBy } }) => (
                    <SidebarChat key={id} id={id} chatName={chatName} chatCreator={createdBy} />
                ))}
            </div>

            <div className="sidebar__footer">
                <Avatar
                    onClick={() => auth.signOut()}
                    src={user.photo}
                    className="sidebar__avatar"
                />
                <div className="sidebar__user">

                    <h4>{user.displayName}</h4>
                </div>

                <IconButton variant="outlined" className="sidebar__inputButton">
                    <AddCircleIcon onClick={addChat} />
                </IconButton>

                <IconButton variant="outlined" className="sidebar__signout">
                    <ReplyAllOutlinedIcon onClick={() => auth.signOut()} />
                </IconButton>
            </div>

        </div>
    );
}

export default Sidebar;
